import React, { forwardRef } from 'react';

import InputTemplate from '../TemplateNumberFormatInput';

const CepInput = forwardRef((props, ref) => (
  <InputTemplate {...props} formato="#####-###" ref={ref} />
));

export default CepInput;
